/**
 * O que faz: Centraliza as chaves de cache do histórico de cada conversa.
 * Onde usa: Hook de mensagens, ChatWindow e envio de mensagens.
 * Conexões: TanStack Query.
 * Tabelas: chat_mensagens por meio das RPCs do chat.
 * Data: 23/07/2026.
 */
export const chatMessageKeys = {
  all: ['chat-messages'] as const,
  clinic: (clinicaId: string) => [...chatMessageKeys.all, clinicaId] as const,
  conversation: (clinicaId: string, leadId: string) => [
    ...chatMessageKeys.clinic(clinicaId),
    leadId,
  ] as const,
};
